// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b19827ed","977":"5a1fbc0b"}[chunkId] + ".chunk.js";
};